import { render } from "./pageFooter.vue?vue&type=template&id=17b60e5f&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"

import "./pageFooter.vue?vue&type=style&index=0&id=17b60e5f&scoped=true&lang=css"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b60e5f"]])

export default __exports__